<template lang="pug">
  .new-upload-file
    el-upload(
      ref="upload"
      :disabled="disabled"
      action="组件必传项，无意义"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="true"
      :on-change="upload()"
    )
      el-button(
        :disabled="disabled"
        type="primary"
      ) {{ $t('点击上传') }}
</template>

<script>
import axios from 'axios'
import { debounce } from 'lodash'

export default {
  props: {
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    axiosUrl: {
      type: String,
      isRequired: true,
      default () {
        return ''
      }
    },
    params: {
      type: Object,
      isRequired: false,
      default () {
        return {}
      }
    }
  },
  methods: {
    upload () {
      return debounce((file, files) => {
        const formData = new window.FormData()
        files.forEach((f, i) => {
          formData.append('file' + i, f.raw)
        })
        if (Object.keys(this.params).length !== 0) {
          for (var key in this.params) {
            formData.append(key, this.params[key])
          }
        }
        this.$emit('loadingChange', true)
        axios
          .post(this.axiosUrl, formData)
          .then((res) => {
            this.$refs.upload.clearFiles()
            this.$emit('uploadSuccess', res)
            this.$emit('loadingChange', false)
            this.editFileName = res.file_name
            this.editFilePath = res.file_download_path
            this.fileList = res.file_name_list
            this.$message.success(this.$t('上传成功'))
          })
          .catch(err => {
            this.$emit('loadingChange', false)
            throw err
          })
      }, 100)
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
